<div class="tile-container" [ngClass]="rootClassName">
  <div class="tile-content">
    <circle-progress
      class="svg tile-progress-circle"
      [space]="-outerStrokeWidth"
      [percent]="percent"
      [radius]="radius"
      [showTitle]="true"
      [showUnits]="false"
      [showSubtitle]="false"
      [title]="title"
      [titleColor]="titleColor"
      [titleFontSize]="titleFontSize"
      [titleFontWeight]="titleFontWeight"
      [backgroundStroke]="backgroundStroke"
      [outerStrokeWidth]="outerStrokeWidth"
      [outerStrokeGradient]="false"
      [outerStrokeColor]="outerStrokeColor"
      [outerStrokeGradientStopColor]="outerStrokeGradientStopColor"
      [innerStrokeWidth]="outerStrokeWidth"
      [innerStrokeColor]="innerStrokeColor"
      [responsive]="false"
      [clockwise]="true"
      [startFromZero]="true"
      [lazy]="false"
      [animation]="true"
      [animationDuration]="300"
      [showImage]="false"
      [showBackground]="false"
      [showInnerStroke]="true"
      [showZeroOuterStroke]="false"
      [renderOnClick]="false"
    ></circle-progress>
    <div class="tile-legend">
      <span class="tile-text" [ngClass]="isWeb ? 'labelboldlarge': 'labelboldsmall'">
        <span>{{titleLine1|titlecase}}</span>
      </span>
      <span class="tile-text" [ngClass]="isWeb ? 'labelboldlarge': 'labelboldsmall'">
        <span>{{titleLine2}}</span>
      </span>
    </div>
    @if (!isWeb) {
      <div tourAnchor="anchor.status.toggle" class="tile-toggle">
        <button class="tile-toggle-button" (click)="onToggle()">
          <span class="tile-text labelboldsmall">
            <span>{{label|titlecase}}</span>
          </span>
        </button>
      </div>
    }
  </div>
</div>
